import React from 'react'

import { organizations } from 'utils/organizations'

export const OrganizationSchema = ({ market }) => {
  const organization = organizations[market]
  const addOrganizationJsonLd = `${JSON.stringify(organization)}`

  return <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: addOrganizationJsonLd }} key="oganization-jsonld" />
}
